import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

function Footer() {
    const date = new Date()
    const year = date.getFullYear()
    return (
        <footer className="bg-primary">
            <Container>
                <Row>
                    <Col className="text-center py-3 text-white">
                        Copyright &copy; Qiec {year}
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}

export default Footer
